module.exports = __webpack_public_path__ + "a17d279f/img/scraper-icon.df6ccde5.svg";